export default __webpack_public_path__ + "static/TransUnion-d790112665a008f5d12cbdc88c08ce28.svg";